import React from 'react';
import Box from './Box';
import { Helpers } from '../helpers/Helpers';

/** Tarayıcıda açılabilen dosya türleri; bunların dışındakiler yalnız indirilir. */
const ON_IZLENEBILIR = ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg', 'txt'];

/**
 * Dosyanın uzantısını sunucudaki adresinden okur (büyük harf, noktasız).
 * Dosya adı alanında uzantı tutulmuyor; yükleme sırasında kırpılıyor.
 */
export const dosyaUzantisi = (url: string | undefined) => {
    const ad = decodeURIComponent((url ?? '').split('?')[0].split('/').pop() ?? '');
    const nokta = ad.lastIndexOf('.');

    return nokta > 0 ? ad.substring(nokta + 1).toUpperCase() : '';
}

/** RAR, ZIP gibi türlerde ön izleme anlamsız; tarayıcı dosyayı zaten indiriyor. */
export const onIzlenebilirMi = (url: string | undefined) => ON_IZLENEBILIR.includes(dosyaUzantisi(url).toLowerCase());

interface Props {
    /** Dosyanın sunucudaki adresi (API alan adı). */
    url: string | undefined
    /** İndirilen dosyaya verilecek ad; boşsa sunucudaki adı kullanılır. */
    fileName?: string
}

/**
 * Dijital arşiv satırlarındaki iki eylem: ön izleme (büyüteç) ve indirme.
 * Dosyalar arayüzden farklı bir alan adından sunulduğu için indirme, sunucudaki
 * DownloadFile uç noktasından yapılır; tarayıcı dosyayı açmak yerine kaydeder.
 */
const FileArchiveActions = ({ url, fileName }: Props) => {
    if (Helpers.isEmpty(url))
        return null;

    const sunucudakiAd = decodeURIComponent((url ?? '').split('/').pop() ?? '');
    const uzanti = dosyaUzantisi(url);
    const onIzleme = onIzlenebilirMi(url);

    /** Dosya adı alanında uzantı tutulmadığı için indirilen dosyaya uzantıyı geri ekliyoruz. */
    const indirmeAdi = () => {
        if (Helpers.isEmpty(fileName))
            return undefined;

        return fileName!.toLowerCase().endsWith('.' + uzanti.toLowerCase()) || uzanti === ''
            ? fileName
            : fileName + '.' + uzanti.toLowerCase();
    }

    const indir = () => {
        const ad = indirmeAdi();

        const adres = Helpers.getEndpoint() + '/Common/DownloadFile?fileName=' + encodeURIComponent(sunucudakiAd)
            + (Helpers.isEmpty(ad) ? '' : '&downloadName=' + encodeURIComponent(ad!));

        window.location.href = adres;
    }

    return (
        <Box flexDirection='row' justifyContent='flex-end' gap='6px'>
            <Box
                title={onIzleme ? 'Ön izleme' : uzanti + ' dosyası ön izlenemez, indirerek açın'}
                onClick={onIzleme ? () => window.open(url, '_blank') : undefined}
                opacity={onIzleme ? '1' : '0.5'}
                className='actionIcon p-2 bg-primary' justifyContent='center' flexDirection='row' borderRadius='4px'>
                <i className='text-white fa fa-search m-0' />
            </Box>

            <Box title='İndirme' onClick={indir} className='actionIcon p-2 bg-success' justifyContent='center' flexDirection='row' borderRadius='4px'>
                <i className='text-white fa fa-download m-0' />
            </Box>
        </Box>
    )
}

export default FileArchiveActions;
